// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".contract-edit[data-v-1464f620] {\n  height: 100%;\n}\n.contract-edit .list-table[data-v-1464f620] {\n  padding: 0.26667rem;\n}\n.contract-edit .item-table-wrap[data-v-1464f620] {\n  padding: 0 0.42667rem 0.26667rem;\n}\n.contract-edit .muted[data-v-1464f620] {\n  color: #909399;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
